import * as React from 'react';
import { Dispatch, Action } from 'redux';
import { Typography, Paper, List, ListItemText, ListItem } from '@material-ui/core';
import { connect } from 'react-redux';
import * as H from 'history';

import { siteInfoListSubdivOperations } from '../../redux/modules';
import { IAppState } from '../../redux/modules';
import { SiteInfoListSubdivState } from '../../redux/modules/siteInfoListSubdiv';
import { NavLink } from 'react-router-dom';
import { CloseBackButton } from '../parts/CloseBackButton';

interface OwnProps {
  listSiteInfo: () => void;
  clear: () => void;
  siteInfoListSubdiv: SiteInfoListSubdivState;
  history: H.History;
}

class SelectSiteSubdivPage extends React.Component<OwnProps>{
  componentWillMount() {
    this.props.listSiteInfo();
  }
  render() {
    console.log('Site Info List Subdiv Items from Props:', this.props.siteInfoListSubdiv.items);
    return (
    <div>
      <Typography variant="h6">[細分化画像]-対象の工事現場を選択</Typography>
      <Paper style={{ padding: '10px' }}>
        <List>
            {this.props.siteInfoListSubdiv.items.map((item, index) => {
              return (
                <NavLink
                  key={`link_${index}`}
                  style={{textDecoration: 'none', color: 'unset'}}
                  to={`/subdiv/kansatsukiroku/${item.koujiBangou}`}
                >
                  <ListItem
                    button
                    divider
                    key={item.koujiBangou}
                  >
                    <ListItemText
                      primary={item.name}
                      secondary={item.koujiBangou}
                    />
                  </ListItem>
                </NavLink>
              );
            })}
        </List>
      </Paper>
      <CloseBackButton history={this.props.history} />
    </div>
    );
  }
}

function mapDispatchToProps(dispatch: Dispatch<Action<any>>) {
  return {
    listSiteInfo: () => {
      siteInfoListSubdivOperations.list()(dispatch);
    },
    clear: () => {
      siteInfoListSubdivOperations.clear()(dispatch);
    },
  };
}

function mapStateToProps(appState: IAppState) {
  return {
    siteInfoListSubdiv: appState.siteInfoListSubdiv,
    user: appState.user
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectSiteSubdivPage);



// WEBPACK FOOTER //
// ./src/components/subdiv/SelectSiteSubdivPage.tsx